module.exports = __webpack_public_path__ + "resources/img/img_security_dfinder_fds2_en.985ed6c1f585cce78f04a2cb361d36bd.png";